<template>
  <div class="page">
    <div class="head">
      <div class="who">
        <label class="avatar-btn">
          <img class="avatar" :src="avatarUrl" alt="">
          <input class="file" type="file" accept="image/jpeg,image/png,image/gif,image/bmp" @change="onAvatar">
        </label>
        <div>
          <div class="name">{{ profile.nickname || '会员' }}</div>
          <div class="phone">{{ profile.phone }}</div>
        </div>
      </div>
    </div>
    <div class="cards">
      <button v-for="item in cards" :key="item.to" class="card" type="button" @click="$router.push(item.to)">
        <span class="card-top">
          <span class="mark" :style="{ background: item.bg, color: item.color }">
            <van-icon :name="item.icon" />
          </span>
          <span class="label">{{ item.label }}</span>
        </span>
        <span class="card-bottom">
          <span class="num">{{ money(profile[item.field]) }}</span>
          <span class="more">查看明细</span>
        </span>
      </button>
    </div>
    <div class="entries">
      <button v-for="item in entries" :key="item.to" class="entry" type="button" @click="$router.push(item.to)">
        <span class="entry-main">
          <span class="mark" :style="{ background: item.bg, color: item.color }">
            <van-icon :name="item.icon" />
          </span>
          <span>{{ item.label }}</span>
        </span>
        <van-icon class="entry-arrow" name="arrow" />
      </button>
    </div>
    <button class="quit" type="button" @click="exit">退出登录</button>
  </div>
</template>

<script>
import { getProfile, logout, money, updateAvatar } from '../api'
import { assetUrl } from '../utils/asset'
import defaultAvatar from '../assets/member-avatar.jpg'

export default {
  data() {
    return {
      profile: {},
      defaultAvatar,
      cards: [
        { label: '积分', field: 'pointsBalance', to: '/points', icon: 'gold-coin-o', color: '#1f6f5b', bg: '#e7f3ef' },
        { label: '兑换值', field: 'exchangeBalance', to: '/exchange', icon: 'gift-o', color: '#c47b2b', bg: '#fbf1e4' },
        { label: '佣金', field: 'commissionTotal', to: '/commission', icon: 'balance-o', color: '#2f6f9f', bg: '#e8f1f8' },
        { label: '累计消费', field: 'consumeTotal', to: '/consume', icon: 'orders-o', color: '#6b5b95', bg: '#f1eef6' }
      ],
      entries: [
        { label: '我的团队', to: '/team', icon: 'friends-o', color: '#1f6f5b', bg: '#e7f3ef' },
        { label: '邀请好友', to: '/invite', icon: 'share-o', color: '#c47b2b', bg: '#fbf1e4' },
        { label: '意见反馈', to: '/feedback', icon: 'comment-o', color: '#2f6f9f', bg: '#e8f1f8' },
        { label: '关于我们', to: '/about', icon: 'info-o', color: '#6b5b95', bg: '#f1eef6' }
      ]
    }
  },
  computed: {
    avatarUrl() {
      return this.profile.avatar ? assetUrl(this.profile.avatar) : this.defaultAvatar
    }
  },
  created() {
    getProfile().then(res => { this.profile = res.data || {} })
  },
  methods: {
    money,
    onAvatar(event) {
      const file = event.target.files && event.target.files[0]
      event.target.value = ''
      if (!file) return
      updateAvatar(file).then(res => {
        this.profile = res.data || this.profile
        this.$toast('头像已更新')
      })
    },
    exit() {
      logout().finally(() => {
        localStorage.removeItem('h5_token')
        this.$router.replace('/login')
      })
    }
  }
}
</script>

<style scoped>
.page { min-height: 100vh; display: flex; flex-direction: column; }
.head { display: flex; align-items: center; background: linear-gradient(160deg, #1f6f5b, #2f8f74); color: #fff; padding: 28px 16px 56px; }
.who { display: flex; align-items: center; }
.avatar-btn { display: block; margin-right: 12px; cursor: pointer; }
.avatar { width: 52px; height: 52px; border-radius: 50%; object-fit: cover; border: 2px solid rgba(255,255,255,0.7); display: block; }
.file { display: none; }
.name { font-size: 20px; font-weight: 600; }
.phone { margin-top: 4px; opacity: 0.85; font-size: 13px; }
.quit { margin: auto 16px 24px; height: 44px; border: 1px solid #ee0a24; background: #fff; color: #ee0a24; border-radius: 22px; font-size: 15px; }
.cards { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin: -36px 12px 12px; }
.card { text-align: left; background: #fff; border: 0; border-radius: 12px; padding: 14px; box-shadow: 0 6px 16px rgba(31, 111, 91, 0.08); }
.card-top { display: flex; align-items: center; }
.card-bottom { display: flex; align-items: center; justify-content: space-between; margin-top: 12px; }
.card .mark { width: 28px; height: 28px; border-radius: 8px; display: inline-flex; align-items: center; justify-content: center; font-size: 16px; flex: none; }
.label { margin-left: 8px; color: #888; font-size: 13px; }
.num { font-size: 20px; font-weight: 700; }
.more { color: #1f6f5b; font-size: 12px; white-space: nowrap; }
.entries { display: flex; flex-direction: column; gap: 10px; margin: 0 12px; }
.entry { display: flex; align-items: center; justify-content: space-between; width: 100%; background: #fff; border: 0; border-radius: 12px; padding: 14px; font-size: 15px; }
.entry-main { display: flex; align-items: center; }
.entry .mark { width: 36px; height: 36px; border-radius: 10px; display: flex; align-items: center; justify-content: center; margin-right: 10px; font-size: 18px; flex: none; }
.entry-arrow { color: #c8c8c8; font-size: 16px; }
</style>
